import React, { useEffect } from 'react';
import '../../styles/DigitalBalanceModal.css';

interface ModalProps {
  metalName: string;
  availableBalance: number;
  usedBalance: number;
  usedBalanceStr: string;
  errorMessage: string;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isContinueDisabled: boolean;
  handleUseMetalBalance: () => void;
  handleCancelClick: () => void;
  sellQuantity: number;
}

const DigitalBalanceModal: React.FC<ModalProps> = ({
  metalName,
  availableBalance,
  usedBalance,
  usedBalanceStr,
  errorMessage,
  handleInputChange,
  isContinueDisabled,
  handleUseMetalBalance,
  handleCancelClick,
  sellQuantity,
}) => {
  useEffect(() => {
    const prefillValue = Math.min(availableBalance, sellQuantity).toFixed(4);
    const event = {
      target: { value: prefillValue },
    } as React.ChangeEvent<HTMLInputElement>;
    handleInputChange(event);
  }, [availableBalance, sellQuantity]);


  const remaining = availableBalance - usedBalance;
  const safeRemaining = Math.max(0, Math.round(remaining * 10000) / 10000);


  return (
    <div className='custom-modal-overlay'>
      <div className='custom-modal-container'>
        <button className='custom-modal-close' onClick={handleCancelClick}>
          &times;
        </button>
        <h5 className='custom-modal-title'>{`Redeem from ${metalName} Balance`}</h5>
        <p className='custom-modal-subtitle'>
          Digital {metalName} Balance: <strong>{availableBalance.toFixed(4)} g</strong>
        </p>
        <label className='custom-modal-label'>
          Enter Grams to use from Balance
        </label>
        <div className='custom-input-wrapper'>
          <input
            type='text'
            className='custom-modal-input'
            value={usedBalanceStr}
            onChange={handleInputChange}
            placeholder='0.0000'
          />
          <span className='custom-input-unit'>g</span>
        </div>
        {errorMessage && <p className='custom-input-error'>{errorMessage}</p>}
        {/* <p className='custom-wallet-remaining'>
          Remaining {metalName} Balance:{' '}
          <strong>{(availableBalance - usedBalance).toFixed(4)} g</strong>
        </p> */}
        <p className='custom-wallet-remaining'>
          Remaining {metalName} Balance:{' '}
          <strong>{safeRemaining.toFixed(4)} g</strong>
        </p>

        <button
          className='custom-modal-continue-btn'
          onClick={handleUseMetalBalance}
          disabled={usedBalance <= 0 || isContinueDisabled}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default DigitalBalanceModal;
